import * as types from "./mutation-types";

export default {
  [types.SET_PEDIDOS](state, payload) {
    state.pedidos = payload;
  },
  [types.SET_PEDIDO](state, payload) {
    state.pedido = payload || {};
  },
  [types.SET_PAGAMENTO](state, payload) {
    state.pagamento = payload || {};
  },
  [types.SET_PAGAMENTOS_HISTORICO](state, payload) {
    state.pagamentosHistorico = payload || [];
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload || {};
  },
  [types.SET_ERROR](state, payload) {
    state.error = payload || {};
  },
};
